import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import APIKeyModal from '../APIKeyModal/APIKeyModal';
import { CardHandler } from '../APIKeyPM/APIKeyPM.utils';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import clientHubLogoUrl from './client-hub-logo.png';
export const GetClientHubCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ClientHubCardTID: {
                Card: 'client-hub-card',
                Connect: 'client-hub-card-connect'
            }
        }
    });
const ClientHubCard = (param)=>{
    let { integration } = param;
    const { t: clientHubTexts } = useLocaleKeys('integrations.availableApps.clientHub');
    const { ClientHubCardTID } = useMemo(()=>GetClientHubCardTID(), []);
    const navigate = useNavigate();
    const overlayContext = useOverlayContext();
    const { api } = useStoreActions();
    const { refresh: refreshIntegrations } = useIntegrations({
        enabled: false
    });
    const ui = {
        goToPage: (page)=>navigate(page),
        requestApiKey: (apiKeyListener)=>overlayContext.showModal({
                biName: 'api_key_modal',
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(APIKeyModal, {
                        pmName: PracticeManagement.ClientHub,
                        dismissModal: dismissModal,
                        apiKeyListener: apiKeyListener
                    });
                }
            }),
        refetchIntegrations: async ()=>{
            await refreshIntegrations({
                throwOnError: false
            });
        }
    };
    const server = {
        saveApiKey: async (apiKey)=>api.clientHub.setAPIKey(apiKey)
    };
    const clientHubCardHandler = new CardHandler(ui, integration, server);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: ClientHubCardTID.Card(),
        title: clientHubTexts.title(),
        subTitle: clientHubTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_client_hub'
            },
            testId: ClientHubCardTID.Connect(),
            onClick: ()=>clientHubCardHandler.handleClick(routes.clientHubSetup),
            children: clientHubCardHandler.getActionText()
        }),
        icon: /*#__PURE__*/ _jsx(IntegrationCard.LogoImg, {
            alt: "client hub logo",
            src: clientHubLogoUrl
        }),
        disclaimer: clientHubTexts.disclaimer()
    });
};
export default ClientHubCard;
